import { userService } from '../services';
import { router } from '../helpers';

const user = JSON.parse(localStorage.getItem('user'));


const state = user
    ? { status: { loggedIn: true }, user, permissions: null, loaded_permissions: false, userdetails: null, tenantdetails: null }
    : { status: {}, user: null, permissions: null, loaded_permissions: false, userdetails: null, tenantdetails: null};

const actions = {
    login2Fa({ dispatch, commit }, { code_2fa, token_2fa, tenantId}) {
        userService.verifyTwoFactorLogin(code_2fa,token_2fa,tenantId).then(user => {
                    commit('loginSuccess', user);
                    dispatch('getpermissions');
                    router.push('/');
        },
            error => {
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            });
    },
    login({ dispatch, commit }, { username, password,company}) {
        commit('loginRequest', { username });
    
        if(company && company.length > 0)
        {
            return new Promise((resolve, reject) => {
                userService.checkIfCompanyAvailable(company)
                    .then(resp=> {
                            if(resp.data!=null && resp.data.result!=null && resp.data.result.tenantId)
                            {

                                userService.login(username, password,resp.data.result.tenantId)
                                    .then(
                                        user => {
                                            if(!user.requires2FA) {
                                                commit('loginSuccess', user);
                                                dispatch('getpermissions');
                                                router.push('/');
                                            }
                                            else
                                            {
                                                resolve(user);
                                            }
                                        },
                                        error => {
                                            commit('loginFailure', error);
                                            dispatch('alert/error', error, { root: true });
                                            reject(error);
                                        }
                                    );
                            }
                            else
                            {
                                commit('loginFailure', '');
                                dispatch('alert/error', 'Błąd logowania.', { root: true });
                            }
                        },
                        error=> {
                            commit('loginFailure', error);
                            dispatch('alert/error', error, { root: true });
                        })

            });

        }
        else
        {
            userService.login(username, password,0)
            .then(
                user => {
                    commit('loginSuccess', user);
                    dispatch('getpermissions');
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );            
        }

    },
    logout({ commit }) {
        userService.logout();

        commit('logout');
    },
    getpermissions({commit}) {
        commit('beforeRefreshPermissions');

        userService.getCurrentUserPermissions().then(
            resp => {
                if(resp != null && resp.userPermissions !=null)
                    commit('refreshPermissions',resp.userPermissions);
                else
                    commit('refreshPermissions',null);

                if(resp != null && resp.user != null)
                    commit('refreshCurrentUserDetails',resp.user)
                else
                    commit('refreshCurrentUserDetails',null)

                if(resp != null && resp.tenant != null)
                    commit('refreshCurrentTenantDetails',resp.tenant)
                else
                    commit('refreshCurrentTenantDetails',null)


            }
        ).catch(() => commit('refreshPermissions',null));
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },    
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.permissions = null
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.permissions = null
        state.user = null;
        state.loaded_permissions = false;
        state.userdetails = null;
        state.tenantdetails = null;
    },
    beforeRefreshPermissions(state) {
        state.loaded_permissions = false;
        state.permissions = null
    },
    refreshPermissions(state,permissions)  {
        state.permissions = permissions;        
    },
    abilityRefreshed(state) {                
        state.loaded_permissions = true;
    },
    refreshCurrentUserDetails(state,userdetails)
    {
        state.userdetails = userdetails
    },
    refreshCurrentTenantDetails(state,tenantdetails)
    {
        state.tenantdetails = tenantdetails
    }
};
const getters = {
    status_permissions: state => {
        return state.loaded_permissions },
    user_details: state => {
        return state.userdetails
    },
    tenant_details: state => {
        return state.tenantdetails
    }
}
export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};